<template>
   <div class="gens-universes">
       <div class="gens-detail">
           <div class="detail-content">
               <div class="post_image">
                    <img class="post_image_img" src="../../assets/images/gensunicerse/201125-feature-measles.jpg"/>
               </div>
               <div class="post_text">
                   <div class="post_tip">葉酸代謝基因檢測 呵護媽媽同BB</div>
                   <div class="post_info">Posted at 09:00h in 生育健康</div>
                   <p class="post_wrapper">葉酸和新生兒的神經管發育有很大的關聯，若孕婦再懷孕初期無法提供給胎兒足夠的葉酸，會增加胎兒神經管畸形的機率，且孕婦自身也容易產生貧血等症狀，流產、早產的機率也會增加。</p>
                    <div class="post_tip_1">
                        葉酸，又名維他命B9，是一種水溶性維他命，人體自身無法合成，需通過飲食或葉酸補充劑獲得。
                    </div>
                    <div class="post_wrapper_img"><img  src="../../assets/images/gensunicerse/201125-1.jpg" /></div>
                    <div class="post_wrapper_tip">葉酸缺乏的危害</div>
                    <div class="post_wrapper_1">
                        葉酸參與人體的新陳代謝，是合成DNA所必須的元素，也是細胞生長和分裂所必備的物質，更是胚胎發育過程中不可缺少的營養素。
                        因此，對於孕期婦女而言，葉酸的缺乏增加了妊娠期併發症發生的風險、提高了多種不良妊娠結局的發生率。<br><br>
                        葉酸缺乏可能導致以下風險：<br>
                         胎兒：神經管畸形、唇裂、先天性心臟病<br>
                         孕婦：貧血、早產
                    </div>
                    <div class="post_wrapper_tip">葉酸過量的危害</div>
                    <div class="post_wrapper_1">葉酸在身體內的吸收和轉化能力是有限的，葉酸過量會導致未代謝的葉酸在體內累積從而對機體造成危害。<br><br>
                        葉酸過量可能導致以下風險：<br>
                         掩蓋缺乏維他命B12的症狀(惡性貧血)<br>
                         對癌症、抑鬱、認知障礙等產生不良影響</div>
                    <div class="post_wrapper_tip">科學補充葉酸</div>
                    <div class="post_wrapper_1">通過檢測MTHFR基因的2個常見突變位點，可以得知MTHFR葉酸代謝酶的活性，從而科學地補充葉酸。</div>     
                    <div class="post_wrapper_img">
                        <img  src="../../assets/images/gensunicerse/201125-2.jpg"/>
                    </div><br>
                    <div class="post_wrapper_1">1、葉酸可耐受最高攝入量為每日1000微克，超過此攝入量可能會掩蓋維他命B12缺乏的症狀(惡性貧血)。<br>
                                                2. 對於有神經管畸形妊娠史的婦女，必須謹遵醫生建議進行葉酸的補充。</div>
                    <div class="post_wrapper_tip">葉酸補充途徑</div>
                    <div class="post_wrapper_1">
                        通過對MTHFR基因其相關位點的檢測，根據個人情況選擇葉酸補充途徑
                    </div>
                    <div class="post_wrapper_img">
                        <img  src="../../assets/images/gensunicerse/201125-3.jpg"/>
                        </div>
                    <div class="post_wrapper_tip">檢測內容</div>
                    <div class="post_wrapper_1">此測試利用聚合酶鏈鎖反應(PCR)技術分析MTHFR 基因的2 個常見的突變位點。</div>
                    <div class="post_wrapper_img">
                        <img  src="../../assets/images/gensunicerse/201125-4.jpg"/>
                    </div>
                    <div class="post_wrapper_tip">檢測規格</div>
                    <div class="post_wrapper_1">樣本要求6 mL靜脈血<br>
                                                檢測週期1個工作日</div>
                    
                    <div class="post_wrapper_tip">適用人群</div>
                    <div class="post_wrapper_1">1、備孕或懷孕中的婦女<br>

                                                    2、曾懷有神經管缺陷胎兒的婦女<br>

                                                    3、有習慣性流產、早產、曾懷有畸胎的婦女<br>

                                                    4、有家族心臟血管病史的孕婦<br>

                                                    5、有貧血病史的孕婦</div>
                        <div class="post_tip_1">
                            為甚麼要做葉酸代謝基因檢測?
                        </div>  
                        <div class="post_wrapper_1">葉酸在人體內必須代謝為5-甲基四氫葉酸才能被有效利用，當 MTHFR基因發生突變時，MTHFR酶活性降低，無法有效地將葉酸轉化為人體可利用的成分，因此MTHFR基因突變的人需要適當增加葉酸的攝入量。</div>                          
                        <div class="post_wrapper_img">
                            <img  src="../../assets/images/gensunicerse/201125-5.jpg"/>
                        </div><br>
                        <div class="post_wrapper_1">葉酸代謝基因檢測還是很有必要做的，能幫助孕媽更加清楚地明確自己的葉酸利用水平及所需葉酸劑量，實現科學增補葉酸，為孕媽和胎寶寶保駕護航。</div>
                    
               </div>
           </div>
           <div class="detail-list-menu">
               <div class="list-menu-item">
                   	<h5>最新資訊</h5>		
                       <ul>
							<li>
					            <a href="#/gensone">無免疫力孕婦的患麻疹 最嚴重可流產</a>
							</li>
							<li>
					            <a href="#/genstwo">無入侵性抽血驗癌症 適宜年老病人</a>
							</li>
							<li>
					            <a href="#/gensthree">最易被忽略的一種過敏食物</a>
							</li>
							<li>
					            <a href="#/gensfour">樂觀女性生仔機會較大</a>
						    </li>
							<li>
					            <a href="#/gensfive">雙胞胎兒竟然是同母異父</a>
							</li>
					</ul>
               </div>
               <div class="list-menu-item">
                   <h5>分類</h5>		
                   <ul>
				       <li>
                           <a href="#/gensuniversecate?categoryName=传染病&isCategory=1">傳染病</a> (2)
                       </li>
                       <li >
                           <a href="#/gensuniversecate?categoryName=天赋基因&isCategory=1">天賦基因</a> (1)
                        </li>
                        <li >
                            <a href="#/gensuniversecate?categoryName=无创产前检测&isCategory=1">無創產前檢測</a> (2)
                        </li>
                        <li >
                            <a href="#/gensuniversecate?categoryName=生育健康&isCategory=1">生育健康</a> (4)
                        </li>
                        <li >
                            <a href="#/gensuniversecate?categoryName=癌症&isCategory=1">癌症</a> (4)
                        </li>
                        <li>
                            <a href="#/gensuniversecate?categoryName=致敏原&isCategory=1">致敏原</a> (1)
                        </li>
                        <li>
                            <a href="#/gensuniversecate?categoryName=亲子鉴定&isCategory=1">親子鑑定</a> (1)
                        </li>
                        <li>
                            <a href="#/gensuniversecate?categoryName=遗传病&isCategory=1">遺傳病</a> (1)
                        </li>
                    </ul>
               </div>
           </div>
       </div>
   </div>
</template>
<script>
export default {
    data(){
        return{
          
        }
    },
    mounted(){

    },
    methods:{

    }
}
</script>


<style lang="scss" scoped>
.gens-universes{
    width: 100%;
    position: relative;
    margin-top:1rem;
    text-align: center;
    font-family: 'Microsoft JhengHei',sans-serif !important;
    margin-bottom:25px;
    margin-top:25px;
    .gens-detail{
        text-align: left;
        margin-top:10px;
        width:57.5%;
        margin:auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .detail-content{
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            width:66.66%;
            .post_image{
                position: relative;
                width: 100%;
                display: block;
                .post_image_img{
                   max-width: 100%;
                   height: auto; 
                }
            }
            .post_text{
                .post_tip{
                    margin-top:35px;
                    color: #368da7;
                    font-size: 28px;
                    font-style: normal;
                    font-weight: 600;
                    letter-spacing: 0;
                    text-transform: none;
                }
                .post_info{
                    display: inline-block;
                    width: 100%;
                    margin: 0 0 18px;
                    color: #bebebe;
                    font-weight: 500;
                    line-height: 27px;
                    font-size: 16px;
    
                }
                .post_wrapper{
                    
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;
                    display: block;
                }
                .post_tip_1{
                    margin-top:35px;
                    border-color: #368da7;
                    background-color: #e9faff;
                    padding: 14px 14px 14px 10px;
                    border-left: 4px solid #368da7;
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;

                }
                .post_wrapper_1{
                    margin-top:10px;
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;
                }
                .post_wrapper_1 a{
                    color:#368da7;
                    text-decoration: none;
                }
                .post_wrapper_1 a:hover{
                    color:#9bd9dd;;
                    text-decoration: none;
                }
                .post_wrapper_tip{
                    margin-top:35px;
                    font-size: 18px;
                    font-style: normal;
                    font-weight: 600;
                    text-transform: none;
                    color: #368da7;
                }
                .post_wrapper_img{
                    margin-top:35px;
                    text-align: center;
                    img{
                        vertical-align: middle;
                        height: auto;
                        max-width: 100%;
                    }
                    .bottom_tip{
                        margin-top: .2em;
                       font-size: .8em;
                    }
                }
            }
            
        }
        .detail-list-menu{
            width: 33.33%;
            display: flex;
            padding-left:40px;
            justify-content: left;
            align-items: flex-start;
            flex-direction: column; 
            align-self: flex-start;
            .list-menu-item{

                width:100%;
                background-color: #f3f3f3!important;
                padding: 14px!important;
                box-shadow: 4px 4px 5px #cfcfcf;
                margin: 0 0 42px;
            }
            .list-menu-item h5{
                 color: #368da7!important;
                 font-size: 18px;
                font-style: normal;
                font-weight: 600;
                text-transform: none;
            }
            .list-menu-item ul{
                list-style: none;
                padding: 0;
                background: 0 0;
                border: 0;
                margin: 0;
                padding: 0;
                vertical-align: baseline;
                outline: 0;
                color: #3b3b3b;
            }
            .list-menu-item li{
                line-height: 27px;
                letter-spacing: .07em!important;
                font-size: 14px;
                padding: 5px 0;
                margin: 0;
                vertical-align: baseline;
            }
            .list-menu-item a{
                
                text-decoration: none;
                color:  #303030 !important;
                font-weight: 400;
            }
            .list-menu-item a:hover{
                color: #9bd9dd !important;
                font-weight: 400;
            }
        }
    }

           
}
</style>


// WEBPACK FOOTER //
// src/view/gensuniversedetail/gensfourteen.vue